import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input } from 'antd';
import { Button } from '@cropler/ui-kit';
import styles from './styles.module.scss';
import imageUrl from '../../assets/images/sentek-soil-sensor.jpg';
import { sensorsApi, useCreateSensorSettingsSoilSensorMutation } from '../../store/api/sensors';

const SoilSensorConnectModal = ({ t, id, onCloseModal }) => {
  const dispatch = useDispatch();
  const [formConnect] = Form.useForm();
  const [formError, setFormError] = useState('');

  // const [
  //   updateSoilSensor,
  //   { isSuccess: isUpdateSoilSensorSuccess, isError: isUpdateSoilSensorError, error: updateSoilSensorError },
  // ] = useUpdateSensorSettingsSoilSensorMutation();

  const [
    createSoilSensor,
    { isSuccess: isCreateSoilSensorSuccess, isError: isCreateSoilSensorError, error: createSoilSensorError },
  ] = useCreateSensorSettingsSoilSensorMutation();

  const onConnect = () => {
    setFormError('');
    formConnect
      .validateFields()
      .then((values) => {
        createSoilSensor({ sensorId: id, serialNumber: values.serialNumber });
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  const handleCodeChange = () => {
    if (formError) setFormError('');
  };

  // Errors
  useEffect(() => {
    if (isCreateSoilSensorError && createSoilSensorError) {
      setFormError(
        createSoilSensorError[0].code === 'not_found' ? t('soil.serialNumberNotFound') : createSoilSensorError[0].detail,
      );
    } else {
      setFormError('');
    }
  }, [isCreateSoilSensorError, createSoilSensorError]);

  // Success, close modal
  useEffect(() => {
    if (!isCreateSoilSensorSuccess) return;
    dispatch(sensorsApi.util.resetApiState());
    onCloseModal();
  }, [isCreateSoilSensorSuccess]);

  return (
    <div className={styles.connectSoilSensor}>
      <div className={styles.connectSoilSensorBody}>
        <h2 className={styles.connectSoilSensorTitle}>Connect Sentek Soil Sensor</h2>
        <p>To link your soil sensor, enter the serial code printed on the top of the Sentek cap.</p>
        <Form form={formConnect} layout="vertical" size={'large'} requiredMark="optional">
          <Form.Item
            name="serialNumber"
            label={t('soil.serialNumber')}
            rules={[
              { required: true, message: t('form.validation.required') },
              { max: 8, min: 8, message: t('soil.serialNumberParams') },
            ]}
          >
            <Input placeholder="XXXXXXXX" onChange={handleCodeChange} />
          </Form.Item>
        </Form>
        {formError && <div className={styles.formErrors}>{formError}</div>}
        <div className={styles.connectSoilSensorNav}>
          <Button type={'secondary'}>Cancel</Button>
          <Button type={'primary'} onClick={onConnect}>
            {t('actions.connect')}
          </Button>
        </div>
      </div>
      <div className={styles.connectSoilSensorImage}>{imageUrl && <img src={imageUrl} alt="Sentek" width={270} />}</div>
    </div>
  );
};

export default SoilSensorConnectModal;
